jQuery( $ => {
	$( '[data-gtranslate-toggle]' ).on( 'click', function() {
		const headerElement = $( '#masthead' );

		headerElement.toggleClass( 'gtranslate-open' );

		$( this ).attr( 'aria-expanded', ( i, attr ) => {
			return 'true' === attr ? 'false' : 'true';
		} );

		$( '#gtranslate-container' ).slideToggle( 150, function() {
			const switcherA = document.querySelector( '#gtranslate-container a' );
			const headerEl = document.querySelector( '#masthead' );

			if ( headerEl.classList.contains( 'gtranslate-open' ) === true ) {
				setTimeout( function() {
					switcherA.click();
				}, 150 );
			}
		} );
	} );
} );
